import { NETWORK_ICON_MAP } from "../../utils/networkConstants";
import { formatStat } from "../../helper/statsFormatter";
export const CHANNEL_ICON_MAP = {
    ...NETWORK_ICON_MAP,
    "google_search": NETWORK_ICON_MAP.adword,
    "google search": NETWORK_ICON_MAP.adword,
    "google search ads": NETWORK_ICON_MAP.adword,
    "google ads": NETWORK_ICON_MAP.adword,
    "google_ads": NETWORK_ICON_MAP.adword,
    "google display": NETWORK_ICON_MAP.adword,
    "google shopping": NETWORK_ICON_MAP.adword,
    "google_shopping": NETWORK_ICON_MAP.adword,
    "google": NETWORK_ICON_MAP.adword,
    "adwords": NETWORK_ICON_MAP.adword,
    "facebook": NETWORK_ICON_MAP.meta,
    "instagram": NETWORK_ICON_MAP.meta,
    "amazon": "/assets/others.svg",
    "tiktok": "/assets/others.svg",
    "pepperjam": NETWORK_ICON_MAP.pepperjam,
};
export const getChannelIcon = (channel) => {
    if (!channel)
        return null;
    const key = channel.toLowerCase().replace(/_/g, " ").trim();
    if (CHANNEL_ICON_MAP[key])
        return CHANNEL_ICON_MAP[key];
    if (key.includes("google"))
        return CHANNEL_ICON_MAP["google"];
    if (key.includes("bing"))
        return CHANNEL_ICON_MAP["bing"];
    if (key.includes("meta") || key.includes("facebook") || key.includes("instagram"))
        return CHANNEL_ICON_MAP["meta"];
    if (key.includes("criteo"))
        return CHANNEL_ICON_MAP["criteo"];
    if (key.includes("impact"))
        return CHANNEL_ICON_MAP["impact"];
    if (key.includes("awin"))
        return CHANNEL_ICON_MAP["awin"];
    if (key.includes("rakuten"))
        return CHANNEL_ICON_MAP["rakuten"];
    if (key.includes("cj") || key.includes("commission junction") || key.includes("commission_junction"))
        return CHANNEL_ICON_MAP["cj"];
    if (key.includes("pepperjam"))
        return CHANNEL_ICON_MAP["pepperjam"];
    if (key.includes("klaviyo"))
        return CHANNEL_ICON_MAP["klaviyo"];
    if (key.includes("shopify"))
        return CHANNEL_ICON_MAP["shopify"];
    return null;
};
export const formatChannelName = (channel) => {
    if (!channel)
        return channel;
    const lower = channel.toLowerCase();
    if (lower === 'facebook ads' || lower === 'facebook')
        return 'Meta';
    return channel;
};
export const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "")
        return "$0.00";
    return formatStat(value, "revenue");
};
export const formatDate = (date) => {
    if (!date)
        return '-';
    const d = new Date(date);
    if (isNaN(d.getTime()))
        return '-';
    return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
export const TYPE_LABEL_MAP = {
    paid_media: 'Paid Media',
    affiliate: 'Affiliate'
};
export const labelStyle = {
    fontSize: '13px',
    color: '#344054',
    fontWeight: 500,
};
export const valueStyle = {
    fontSize: '13px',
    color: '#667085',
    fontWeight: 400,
};
export const formatValue = (value, suffix = '') => {
    if (value === null || value === undefined || value === '')
        return '-';
    return `${value}${suffix}`;
};
